module.exports = __webpack_public_path__ + "static/img/gou.3e142ae6.png";